import { Stack, Typography } from '@mui/material';
import { Gauge } from '@mui/x-charts-pro';
import DataCard, {
  DataCardProps,
} from 'components/data-card/data-card.component';
import { defaultValueFormatter } from 'components/data-card/data-card.utils';
import PreviousPeriodDataCardDescription, {
  PreviousPeriodDataCardDescriptionProps,
} from './previous-period-data-card-description/previous-period-data-card-description.component';
import { maxPercent } from './previous-period-data-card.utils';

export type PreviousPeriodDataCardProps = DataCardProps & {
  previousPeriodPercent: number;
  PreviousPeriodDataCardDescriptionProps?: Partial<PreviousPeriodDataCardDescriptionProps>;
};

export const PreviousPeriodDataCard = ({
  title,
  value,
  valueType,
  previousPeriodPercent,
  slots,
  PreviousPeriodDataCardDescriptionProps = {},
  ...rest
}: PreviousPeriodDataCardProps) => {
  return (
    <DataCard
      title={title}
      value={value}
      valueType={valueType}
      slots={{
        ...slots,
        value: valueType === 'percent' && (
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="cardValue" component="div">
              {defaultValueFormatter(value, valueType)}
            </Typography>
            <Gauge
              width={28}
              height={28}
              value={maxPercent(value)}
              startAngle={-90}
              endAngle={90}
              text={null}
              valueMax={1}
              margin={{
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              }}
              data-testid="PreviousPeriodDataCard.Gauge"
              sx={{
                flexGrow: 0,
                alignItems: 'flex-start',
              }}
            />
          </Stack>
        ),
        description: (
          <PreviousPeriodDataCardDescription
            previousPeriodPercent={previousPeriodPercent}
            {...PreviousPeriodDataCardDescriptionProps}
          />
        ),
      }}
      {...rest}
    />
  );
};
export default PreviousPeriodDataCard;
